<template>
    <div id="app" ref="app">

      <router-view></router-view>
<!--      <div class="floating-component">-->
<!--        <el-tooltip placement="left" effect="light" popper-class="too">-->
<!--          <div slot="content">-->
<!--            <div class="title">综合咨询</div>-->
<!--            <div class="num" @click="callPhone(4000339003)">400-033-9003</div>-->
<!--            <div class="title">售前咨询</div>-->
<!--            <div class="num1" @click="callPhone(13603710470)">13603710470</div>-->
<!--          </div>-->

<!--          <el-button circle class="but"><img src="../src/assets/img/home/call.svg" class="top"/></el-button>-->
<!--        </el-tooltip>-->
<!--      </div>-->
<!--      <div class="floating-component1">-->
<!--          <el-button circle class="but"><img src="../src/assets/img/home/msg.svg" class="top" @click="$router.push('/Experience')"/></el-button>-->
<!--      </div>-->
<!--      <el-backtop :bottom="20" :right="10" >-->
<!--        <el-tooltip placement="right" effect="dark" class="item" content="回到顶部" >-->
<!--        <img src="../src/assets/img/home/top.svg" class="top"/>-->
<!--        </el-tooltip>-->
<!--      </el-backtop>-->
    </div>
</template>

<script>
// import Home from '@/views/Home'
export default {
  name: 'App',
  components: {
    // Home,
  },
  watch: {
    $route() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
  },
  methods:{
    callPhone (num) {
      window.location.href = 'tel://' + num
    },
  }
}
</script>

<style lang="scss">

.production_img_inner {
  width: 70%;
  margin: auto;
  @media screen and (max-width: 768px) {
    width: 95%;
    padding-left: 10PX;
  }
}
a{ text-decoration: none; }

* {
  box-sizing: border-box;
}
@import url('./assets/css/icon.css');

.too.el-tooltip__popper.is-light {
  border: none !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
  padding: 5px;
  @media screen and (max-width: 768px) {
    padding: 5PX !important;
  }
}
/* 修改箭头边框 这里方位是left，所以 x-placement^="left" 并且是设置 border-right-color 的颜色*/
.too.el-tooltip__popper.is-light[x-placement^="left"] .popper__arrow {
  border-left-color: #eaeaea !important;
}
.too.el-tooltip__popper[x-placement^="left"] .popper__arrow {
  border-left-color: #eaeaea !important;
}
</style>
<style lang="scss" scoped>

</style>
